<style lang="scss" scoped>
  .possibilities-block {
    width: 100%;
    max-width: 1020px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 6px;
    padding: 40px 0 60px;
    background: linear-gradient(0deg, #000000 -1.37%, rgba(0, 0, 0, 0) 90.64%), #292E34;

    @include media(max, lg) {
      padding: 50px 40px 0;
      background: none;
      border-radius: 0;
      border-top: 1px solid #32383E;
    }

    @include media(max, md) {
      padding: 20px 0;
    }

    .title {
      text-align: center;
    }

    .possibilities-list {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: 960px;

      @include media(max, lg) {
        display: flex;
        flex-direction: column;
        margin-top: 28px;
      }

      .list-item {
        display: flex;
        flex-direction: column;
        text-align: center;

        @include media(max, lg) {
          text-align: left;
          flex-direction: row;
          margin-bottom: 25px;

          &:last-child {
            margin-bottom: 0;
          }

          [dir=rtl] & {
            text-align: right;
          }
        }

        .item-icon {
          font-size: 80px;
        }

        .item-icon_svg {
          width: 1em;
          height: 1em;
          line-height: 1em;
          background: 50% 50%/cover no-repeat;
          margin: 0 auto;
        }

        .item-info {
          padding: 12px 15px 0;
          margin: 0 auto;
          max-width: 287px;

          @include media(max, lg){
            max-width: none;
            margin: 0;
          }

          @include media(max, md) {
            margin-left: 18px;
            padding: 0;

            [dir=rtl] & {
              margin-left: 0;
              margin-right: 18px;
            }
          }

          .info-title {
            font-size: 28px;
            font-weight: 500;
            line-height: 1.1;
          }

          .info-description {
            margin-top: 15px;
            font-size: 18px;
            line-height: 1.5;
            color: #C3C3C3;

            @include media(max, lg) {
              margin-top: 0;
            }
          }

          .info-link {
            margin-top: 20px;
            font-size: 20px;
            line-height: 22px;

            @include media(max, lg) {
              font-size: 18px;
              margin-top: 10px;
            }

            .link {
              color: $link-color-blue;
              cursor: pointer;

              &:hover {
                color: $link-hover-color-blue;
              }
              &:active {
                color: $link-active-color-blue;
              }
            }
          }
        }

        @include media(max, lg) {
          .item-icon {
            font-size: 50px;
          }

          .item-info {
            padding-top: 0;

            .info-title {
              font-size: 22px;
              line-height: normal;
            }

            .info-description {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
</style>

<template>
  <div class="possibilities-block">
    <div class="title title_section">{{$t('title')}}</div>
    <div class="possibilities-list">
      <div v-for="(block, index) in $t('blocks')" :key="index" class="list-item">
        <div class="item-icon">
          <div class="item-icon_svg"
               :style="{backgroundImage: `url(${baseUrl}images/svg/${block.icon}.svg)`}"></div>
        </div>
        <div class="item-info">
          <div class="info-title" v-html="block.title"></div>
          <div class="info-description" v-html="block.description"></div>
          <div class="info-link">
            <span class="link" @click="scrollToElement(block.link, appIsMobile||appIsTablet ? -100
             : -200)">{{$t('link')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PossibilitiesBlock',
  i18n: {
    messages: {
      ru: {
        title: 'Безграничные возможности',
        link: 'Подробнее',
        blocks: [
          {
            icon: 'gaming',
            title: 'Играйте',
            description: 'Бесплатные и платные игры на&nbsp;любой вкус',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Общайтесь',
            description: 'Находите друзей и делитесь впечатлениями',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Покупайте и&nbsp;продавайте',
            description: 'Находите игровые предметы по выгодным ценам',
            link: 'market-block',
          },
        ],
      },
      en: {
        title: 'Unlock unlimited possibilities',
        link: 'More',
        blocks: [
          {
            icon: 'gaming',
            title: 'Play',
            description: 'Explore a diverse collection of games',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Communicate',
            description: 'Find friends and share your experiences',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Buy and Sell',
            description: 'Get new items and content at awesome prices',
            link: 'market-block',
          },
        ],
      },

      de: {
        title: 'Unbegrenzte Möglichkeiten',
        link: 'Mehr',
        blocks: [
          {
            icon: 'gaming',
            title: 'Spielen',
            description: 'Kostenlose und Premium-Spiele aller Genres',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Chatten',
            description: 'Freunde finden und Ideen teilen',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Kaufen und verkaufen',
            description: 'In-Game-Gegenstände zu Vorteilspreisen finden',
            link: 'market-block',
          },
        ],
      },

      fr: {
        title: 'Opportunités illimitées',
        link: 'Plus',
        blocks: [
          {
            icon: 'gaming',
            title: 'Jouez',
            description: 'Des jeux gratuits et des jeux premium de toutes sortes',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Discutez',
            description: 'Trouvez des amis et partagez vos idées',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Achetez et vendez',
            description: 'Trouvez des objets de jeu à prix fantastiques',
            link: 'market-block',
          },
        ],
      },

      es: {
        title: 'Oportunidades ilimitadas',
        link: 'Más',
        blocks: [
          {
            icon: 'gaming',
            title: 'Jugar',
            description: 'Juegos prémium y gratis de todos los tipos',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Hablar',
            description: 'Encuentra amigos y comparte lo que piensas',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Comprar y vender',
            description: 'Encuentra artículos de juegos a precios de ganga',
            link: 'market-block',
          },
        ],
      },

      tr: {
        title: 'Sınırsız Fırsatlar',
        link: 'Daha fazla',
        blocks: [
          {
            icon: 'gaming',
            title: 'Oyna',
            description: 'Her türden ücretsiz ve premium oyunlar',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Konuş',
            description: 'Arkadaş bul ve fikirlerini paylaş',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Al ve Sat',
            description: 'Ucuz fiyatlara oyun içi eşyalar bul',
            link: 'market-block',
          },
        ],
      },

      pl: {
        title: 'Nieograniczone możliwości',
        link: 'Więcej',
        blocks: [
          {
            icon: 'gaming',
            title: 'Graj',
            description: 'Różnorodne gry darmowe oraz premium',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'Rozmawiaj',
            description: 'Szukaj znajomych i udostępniaj pomysły',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'Kupuj i sprzedawaj',
            description: 'Szukaj przedmiotów w grze w promocyjnych cenach',
            link: 'market-block',
          },
        ],
      },
      ar: {
        title: 'افتح إمكانيات لا حصر لها',
        link: 'المزيد',
        blocks: [
          {
            icon: 'gaming',
            title: 'لعب',
            description: 'استكشف مجموعة متنوعة من الألعاب',
            link: 'shop-block',
          },
          {
            icon: 'speech-bubbles',
            title: 'تواصل',
            description: 'اعثر على الأصدقاء وشارك خبراتك',
            link: 'chatting-block',
          },
          {
            icon: 'buy-and-sell',
            title: 'البيع والشراء',
            description: 'احصل على محتوى وعناصر جديدة بأسعار مذهلة',
            link: 'market-block',
          },
        ],
      },
    },
  },
};

</script>
